import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { AssignmentModel } from "../Assignments Model/assignment-data.model";
import { TrainersModel } from "../Trainers Model/trainers-data.model";

export class StudentTrainerAssignmentGridModel extends TrainersModel { }

export class StudentTrainerAssignmentListingModel extends GridModel<StudentTrainerAssignmentGridModel> { }

export class StudentTrainerAssignmentGridParams extends GridPostParams {
    pageNumber:any= 1
  pageSize:any= 10
  search_key:any='' 
//   trainer_id:any= 3086
//   direction:any='' 
//   column:any='' 
    
  }